<div style="margin-bottom: 24px;">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
    <div style="flex: 1; max-width: 400px;">
      <input 
        type="text" 
        class="form-input"
        [(ngModel)]="searchFilter"
        placeholder="Rechercher un article par mot clé"
        [disabled]="isViewMode">
    </div>
    <button 
      *ngIf="editingIndex === null && !isViewMode" 
      type="button" 
      class="btn btn-primary" 
      (click)="enableQuickAdd()">
      ➕ Ajouter un article
    </button>
  </div>


  <div style="overflow-x: auto; width: 100%;">
    <div style="min-width: 1200px;">
      <table class="data-table" style="table-layout: fixed; width: 100%; border: 1px solid #e5e7eb; border-radius: 8px; border-collapse: separate; border-spacing: 0; overflow: hidden;">
        <colgroup>
          <col style="width: 120px;">
          <col style="width: 150px;">
          <col style="width: 250px;">
          <col style="width: 140px;">
          <col style="width: 130px;">
          <col style="width: 110px;">
          <col style="width: 100px;">
          <col style="width: 130px;">
          <col style="width: 90px;">
        </colgroup>
        <thead style="background: #f9fafb;">
          <tr>
            <th *ngFor="let column of displayedColumns" style="white-space: normal; padding: 12px 8px; border-bottom: 1px solid #e5e7eb; font-weight: 600; font-size: 13px; color: #374151; text-transform: uppercase;">
              {{ column.name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let article of filteredArticles; let numligne = index" style="border-bottom: 1px solid #e5e7eb;">
            <td style="padding: 12px 8px; white-space: normal; word-wrap: break-word;">{{ getArticleData(article, 'typeArticle') }}</td>
            <td style="padding: 12px 8px; white-space: normal; word-wrap: break-word;">{{ getArticleData(article, 'typeConditionnement') }}</td>
            <td style="padding: 12px 8px; white-space: normal; word-wrap: break-word;">{{ getArticleData(article, 'description') }}</td>
            <td style="padding: 12px 8px; text-align: center;">{{ getArticleData(article, 'dimensions') }}</td>
            <td style="padding: 12px 8px; text-align: center;">{{ getArticleData(article, 'hauteur') }}</td>
            <td style="padding: 12px 8px; text-align: center;">{{ getArticleData(article, 'poids') }}</td>
            <td style="padding: 12px 8px; text-align: center;">{{ getArticleData(article, 'quantite') }}</td>
            <td style="padding: 12px 8px; text-align: right;">{{ getArticleData(article, 'prixUnitaire') }}</td>
            <td style="text-align: center; padding: 12px 8px;">
              <div style="display: flex; gap: 4px; align-items: center; justify-content: center;" *ngIf="!isViewMode">
                <button 
                  type="button" 
                  class="btn-icon" 
                  (click)="startEdit(numligne)" 
                  title="Modifier"
                  style="font-size: 16px; padding: 4px 8px;">
                  ✏️
                </button>
                <button 
                  type="button" 
                  class="btn-icon" 
                  (click)="supprimerArticle(numligne)" 
                  title="Supprimer"
                  style="font-size: 16px; padding: 4px 8px;">
                  🗑️
                </button>
              </div>
              <span *ngIf="isViewMode" style="color: #9ca3af;">—</span>
            </td>
          </tr>

          <tr *ngIf="getArticles().value.length === 0">
            <td [attr.colspan]="displayedColumns.length" style="text-align: center; padding: 2rem 1rem; color: #6b7280;">
              <div style="font-size: 40px; opacity: 0.3; margin-bottom: 12px;">📦</div>
              <p style="font-size: 15px; margin-bottom: 6px; font-weight: 500;">Aucun article ajouté</p>
              <p style="font-size: 13px; margin-bottom: 0;">Cliquez sur "➕ Ajouter un article" pour commencer</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
